import gql from 'graphql-tag';

export default gql`
  query ($subject: MongoID) {
    contentGroups(filter: { subject: $subject, alive_contentgroup: CONTENTGROUP_ALIVE }) {
      _id
      name
      description
      index
      status
      certificateconfig {
        status
        name
        description
        timestatus
        certificatetime
        signature {
          typesign
          firstname
          lastname
          signatureURL
        }
        position
        logoURL
        backgroundURL
      }
      contents {
        _id
        name
        type
        statusActive
        public
      }
    }
  }
`;
